module.exports = __webpack_public_path__ + "static/img/career-course-syxd.171d0c97.png";